const j = "build", b = /* @__PURE__ */ new Set(["compaction", "plan", "summary", "title", "alice"]);
function S(i) {
  const t = i.trim().toLowerCase();
  if (!t) return !1;
  if (b.has(t)) return !0;
  const e = t.lastIndexOf("/");
  return !!(e >= 0 && b.has(t.slice(e + 1)));
}
function N(i) {
  return i.filter((t) => !S(t.name));
}
const $ = {
  build: "Assistant",
  Abby: "Abby",
  "Hudson/Itsy": "Itsy",
  "Max/Bitsy": "Bitsy"
};
function T(i, t, e) {
  if (e?.trim() && i.name === j) {
    const o = t?.[i.name];
    return o?.trim() ? o.trim() : e.trim();
  }
  return (t?.[i.name] ?? $[i.name])?.trim() || i.name;
}
function F(i) {
  if (!i || typeof i != "object") return {};
  const t = i, e = [t.agent_display_names, t.agentDisplayNames, t.config && typeof t.config == "object" ? t.config.agent_display_names : void 0, t.data && typeof t.data == "object" ? t.data.agent_display_names : void 0];
  for (const n of e) {
    if (!n || typeof n != "object" || Array.isArray(n)) continue;
    const o = {};
    for (const [s, r] of Object.entries(n))
      typeof s == "string" && typeof r == "string" && r.trim() && (o[s] = r.trim());
    if (Object.keys(o).length > 0) return o;
  }
  return {};
}
const O = ["big-pickle", "big-pickel", "gpt-5.3-chat-latest"];
function _(i) {
  const t = i.trim();
  if (!t) return !0;
  const e = t.toLowerCase();
  return O.some((n) => e.includes(n));
}
function h(i) {
  return i.trim().replace(/^\[H9\]\s*/, "").trim();
}
function A(i) {
  const t = v(i);
  return typeof t == "string" && /^\s*\[H9\]/.test(t);
}
function k(i, t, e) {
  const n = t.trim(), o = e.trim();
  if (!n || !o || !i || typeof i != "object") return;
  const s = i.providers;
  if (Array.isArray(s))
    for (const r of s) {
      if (!r || typeof r != "object") continue;
      const d = r;
      if (String(d.id ?? d.name ?? "").trim() !== n) continue;
      const c = d.models;
      if (c && typeof c == "object" && !Array.isArray(c)) {
        const f = c[o];
        if (f !== void 0) return f;
      }
      if (Array.isArray(c))
        for (const f of c) {
          if (!f || typeof f != "object") continue;
          const l = f, m = String(l.id ?? l.modelID ?? l.name ?? "").trim();
          if (m) {
            if (m.includes("/")) {
              const u = m.indexOf("/"), p = m.slice(0, u).trim(), y = m.slice(u + 1).trim();
              if (p === n && y === o) return f;
            } else if (m === o)
              return f;
          }
        }
    }
}
function K(i) {
  const t = /* @__PURE__ */ new Set(), e = (r) => {
    const d = r.trim();
    d && !_(d) && t.add(d);
  };
  if (!i || typeof i != "object") return [];
  const n = i, o = n.providers;
  if (Array.isArray(o))
    for (const r of o) {
      if (!r || typeof r != "object") continue;
      const d = r, a = String(d.id ?? d.name ?? "").trim(), c = d.models;
      if (Array.isArray(c))
        for (const f of c) {
          if (typeof f == "string" || !f || typeof f != "object" || !A(f)) continue;
          const l = f, m = String(l.id ?? l.modelID ?? l.name ?? "").trim();
          if (m)
            if (m.includes("/")) {
              const u = m.indexOf("/");
              e(`${m.slice(0, u).trim()}/${m.slice(u + 1).trim()}`);
            } else e(a ? `${a}/${m}` : m);
        }
      else if (c && typeof c == "object")
        for (const [f, l] of Object.entries(c)) {
          const m = f.trim();
          !m || !a || !A(l) || e(`${a}/${m}`);
        }
    }
  const s = n.default;
  if (s && typeof s == "object")
    for (const [r, d] of Object.entries(s)) {
      if (typeof d != "string" || !d.trim()) continue;
      const a = d.trim(), c = r.trim(), f = a.includes("/") ? a : c ? `${c}/${a}` : "", l = f.indexOf("/");
      if (l <= 0) continue;
      const m = f.slice(0, l).trim(), u = f.slice(l + 1).trim(), p = k(i, m, u);
      A(p) && e(f);
    }
  return [...t].sort((r, d) => r.localeCompare(d));
}
function g(i) {
  if (!i || typeof i != "object") return;
  const t = i.api;
  if (!t || typeof t != "object") return;
  const e = t.id;
  return typeof e == "string" && e.trim() ? e.trim() : void 0;
}
function v(i) {
  if (!i || typeof i != "object") return;
  const t = i.name;
  return typeof t == "string" && t.trim() ? t.trim() : void 0;
}
function C(i) {
  const t = [];
  if (!i || typeof i != "object") return t;
  const e = i.providers;
  if (!Array.isArray(e)) return t;
  const n = (o, s, r) => {
    const d = o.trim(), a = s.trim();
    if (!d || !a) return;
    const c = `${d}/${a}`, f = r?.trim(), l = {
      providerId: d,
      modelKey: a,
      canonical: c
    };
    f && (l.apiId = f), t.push(l);
  };
  for (const o of e) {
    if (!o || typeof o != "object") continue;
    const s = o, r = String(s.id ?? s.name ?? "").trim(), d = s.models;
    if (Array.isArray(d)) {
      for (const a of d)
        if (typeof a == "string") {
          const c = a.trim();
          if (!c) continue;
          if (c.includes("/")) {
            const f = c.indexOf("/");
            n(c.slice(0, f).trim(), c.slice(f + 1).trim());
          } else r && n(r, c);
        } else if (a && typeof a == "object") {
          const c = a, f = g(c), l = String(c.id ?? c.modelID ?? c.name ?? "").trim();
          if (!l) continue;
          if (l.includes("/")) {
            const m = l.indexOf("/");
            n(l.slice(0, m).trim(), l.slice(m + 1).trim(), f);
          } else r && n(r, l, f);
        }
    } else if (d && typeof d == "object" && !Array.isArray(d))
      for (const [a, c] of Object.entries(d)) {
        const f = a.trim();
        if (!f) continue;
        const l = g(c);
        r && n(r, f, l);
      }
  }
  return t;
}
function x(i) {
  const t = /* @__PURE__ */ new Map(), e = (o, s) => {
    const r = o.trim(), d = s?.trim();
    if (!r || !d) return;
    const a = h(d);
    t.has(r) || t.set(r, a);
  };
  if (!i || typeof i != "object") return t;
  const n = i.providers;
  if (!Array.isArray(n)) return t;
  for (const o of n) {
    if (!o || typeof o != "object") continue;
    const s = o, r = String(s.id ?? s.name ?? "").trim(), d = s.models;
    if (Array.isArray(d))
      for (const a of d) {
        if (typeof a == "string" || !a || typeof a != "object") continue;
        const c = a, f = v(c);
        if (!f) continue;
        const l = g(c), m = String(c.id ?? c.modelID ?? c.name ?? "").trim();
        if (m) {
          if (m.includes("/")) {
            const u = m.indexOf("/"), p = m.slice(0, u).trim(), y = m.slice(u + 1).trim();
            p && y && e(`${p}/${y}`, f);
          } else r && e(`${r}/${m}`, f);
          l && e(l, f);
        }
      }
    else if (d && typeof d == "object" && !Array.isArray(d))
      for (const [a, c] of Object.entries(d)) {
        const f = a.trim();
        if (!f || !r) continue;
        const l = v(c);
        if (!l) continue;
        const m = `${r}/${f}`;
        e(m, l);
        const u = g(c);
        if (c && typeof c == "object") {
          const p = c.id;
          typeof p == "string" && p.trim() && e(p.trim(), l);
        }
        u && e(u, l);
      }
  }
  return t;
}
function M(i, t) {
  const e = typeof i == "string" ? i.trim() : "";
  if (!e) return;
  const n = C(t);
  if (n.length === 0) return e;
  for (const s of n)
    if (s.canonical === e) return s.canonical;
  for (const s of n)
    if (s.apiId && s.apiId === e) return s.canonical;
  const o = n.filter((s) => s.modelKey === e);
  if (o.length === 1) return o[0].canonical;
  if (e.includes("/")) {
    const s = e.indexOf("/"), r = e.slice(0, s).trim(), d = e.slice(s + 1).trim();
    if (d) {
      const a = n.filter((f) => f.modelKey === d);
      if (a.length === 1) return a[0].canonical;
      const c = n.filter((f) => f.providerId === r && f.modelKey === d);
      if (c.length === 1) return c[0].canonical;
    }
  }
  return e;
}
function E(i) {
  const t = i.trim();
  return t && (t.includes("/") ? t.slice(t.lastIndexOf("/") + 1) : t).replace(/-/g, " ");
}
function P(i, t, e) {
  const n = i.trim();
  if (!n) return n;
  const o = e ?? x(t), s = M(n, t) ?? n;
  return o.get(n) ?? o.get(s) ?? E(s);
}
function I(i) {
  if (typeof i == "string" && i.trim()) return i.trim();
  if (i && typeof i == "object") {
    const t = i, e = t.providerID ?? t.provider ?? t.providerId, n = t.modelID ?? t.modelId ?? t.id;
    if (typeof e == "string" && typeof n == "string" && e.trim() && n.trim()) {
      const o = e.trim(), s = n.trim();
      return s.includes("/") ? s : `${o}/${s}`;
    }
  }
}
function D(i) {
  if (!i || typeof i != "object") return;
  const t = i;
  if ("data" in t && t.data && typeof t.data == "object") {
    const o = D(t.data);
    if (o) return o;
  }
  const e = I(t.model);
  if (e) return e;
  const n = t.config;
  if (n && typeof n == "object") {
    const o = I(n.model);
    if (o) return o;
  }
}
function L(i) {
  if (!i || typeof i != "object") return;
  const t = i.default;
  if (!(!t || typeof t != "object"))
    for (const [e, n] of Object.entries(t)) {
      if (typeof n != "string" || !n.trim()) continue;
      const o = n.trim();
      if (o.includes("/")) return o;
      const s = e.trim();
      if (s) return `${s}/${o}`;
    }
}
function H(i) {
  const t = (r) => (M(r.trim(), i.providersConfig) ?? r.trim()).trim(), e = i.selectedAgent ? i.agents.find((r) => r.name === i.selectedAgent) : void 0;
  if (e?.model?.trim()) return t(e.model);
  const n = i.agents.find((r) => r.mode === "primary" && r.name === j) ?? i.agents.find((r) => r.mode === "primary") ?? i.agents[0];
  if (n?.model?.trim()) return t(n.model);
  const o = D(i.assistantServerConfig);
  if (o?.trim()) return t(o);
  const s = L(i.providersConfig);
  return s?.trim() ? t(s) : null;
}
export {
  $ as DEFAULT_AGENT_DISPLAY_NAMES,
  j as DEFAULT_PRIMARY_AGENT_CANONICAL,
  T as agentDisplayLabel,
  E as assistantModelIdFallbackLabel,
  P as assistantModelMenuLabel,
  x as buildAssistantModelIdToLabelMap,
  K as collectModelIdsFromProvidersConfig,
  C as collectProviderModelCanonicalEntries,
  N as filterAgentsVisibleForUi,
  k as findModelValueInProvidersConfig,
  S as isAiAssistantAgentHiddenFromUi,
  _ as isAiAssistantModelIdDenylisted,
  M as normalizeOutgoingAssistantModel,
  F as pickAgentDisplayNamesFromAssistantConfig,
  L as pickGlobalDefaultModelId,
  D as pickTopLevelModelFromAssistantConfig,
  H as resolveDefaultEffectiveModelId,
  h as stripAssistantH9ModelDisplayPrefix
};
